/* unplugin-vue-components disabled */import script from "./UserInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInput.vue?vue&type=script&setup=true&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=36f25c7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f25c7d"]])

export default __exports__